import { styled, Toolbar as MuiToolbar, ToolbarProps as MuiToolbarProps } from "@mui/material";

const StyledToolbar = styled(MuiToolbar)(() => {
  return {
    "&.MuiToolbar-root": {
      padding: "4px 10px",
      minHeight: "36px",
      height: "36px",
    },
  };
});

interface ToolbarProps extends MuiToolbarProps {
  children: React.ReactNode;
}

export const Toolbar: React.FC<ToolbarProps> = ({ children, ...props }) => {
  return <StyledToolbar {...props}>{children}</StyledToolbar>;
};

export default Toolbar;
